export function non_busy_date(date, data) {
  if (data.length == 0) { return date >= new Date().setHours(0, 0, 0, 0) }
  return data.every( days => date.toLocaleDateString('fr-CA') != days.date && date >= new Date().setHours(0, 0, 0, 0));
}